/**
 * SideNavDivider.tsx — skillelinje i side-nav
 *
 * Ren React-komponent som erstatter cds-side-nav-divider.
 */

import styles from './side-nav-divider.module.css';

export default function SideNavDivider() {
  return <li className={styles.divider} aria-hidden="true" />;
}
